import { render, staticRenderFns } from "./LatestTransactions.vue?vue&type=template&id=45a9766a&"
import script from "./LatestTransactions.vue?vue&type=script&lang=ts&"
export * from "./LatestTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports